function getFeatures(flagMap, source) {
  const result = [];
  Object.keys(flagMap).forEach((key) => {
    const val = flagMap[key];
    const sourceVal = source[key];
    if (typeof val === "object" && typeof sourceVal === "object") {
      result.push(getFeatures(val, sourceVal));
    } else if (typeof sourceVal === "string" && Boolean(val)) {
      result.push(sourceVal);
    }
  });
  return result.join(" ");
}
function createFeatureMapper(feature) {
  return function(flagMap) {
    return [feature.base, flagMap ? getFeatures(flagMap, feature) : ""].join(" ").trim();
  };
}
export {
  createFeatureMapper
};
